const errors: Record<string, string> = {
  valueMissing: "Field is required",
  typeMismatch: "Invalid value",
  // expand with other errors (badInput, customError, range, etc).
};

/**
 * Validate a single field ValidityState
 */
const validateField = (
  state: ValidityState | null | undefined,
): string[] | null => {
  if (!state || state.valid) {
    return null;
  }

  const invalid: string[] = [];

  state.valueMissing && invalid.push("valueMissing");
  state.typeMismatch && invalid.push("typeMismatch");
  state.tooLong && invalid.push("tooLong");
  state.tooShort && invalid.push("tooShort");
  // expand to other HTML5 validity props (badInput, customError, range, etc).

  return invalid;
};

/**
 * HTML5 form validation. Collection of errors
 */
export const validateForm = (
  form: HTMLFormElement,
  fields: string[],
): Record<string, string | boolean> => {
  const invalidFields: Record<string, string> = {};

  for (const field of fields) {
    const el = form.elements.namedItem(field);
    const validation = validateField((el as HTMLInputElement | null)?.validity);
    if (Array.isArray(validation) && validation.length > 0) {
      invalidFields[field] = validation[0]; // Only the first error
    }
  }

  const formResults: Record<string, string | boolean> = {};
  for (const [key, value] of Object.entries(invalidFields)) {
    formResults[key] = errors[value];
  }

  formResults["invalid"] = Object.keys(formResults).length > 0;

  return formResults;
};
